<div class="lmc-status-breakdown">

  <div class="sb-total" *ngIf="showTotal">
    <span class="sb-total-label">{{ totalLabel }}</span>
    <span class="sb-total-value">{{ displayTotal }}</span>
  </div>

  <!-- Stacked proportion bar — each segment's flex-grow is its count. -->
  <div class="sb-bar" [class.sb-bar--empty]="!segments.length">
    <span class="sb-seg"
          *ngFor="let seg of segments"
          [style.flex-grow]="seg.count"
          [style.background-color]="seg.color"
          [matTooltip]="seg.label + ': ' + seg.count"></span>
  </div>

  <!-- Legend fits as many columns as the width allows (see SCSS); uniform tracks keep
       labels aligned and counts right-anchored. -->
  <div class="sb-legend">
    <span class="sb-legend-item"
          *ngFor="let item of legendItems"
          [class.is-zero]="item.count === 0">
      <span class="sb-dot" [style.background-color]="item.color"></span>
      <span class="sb-label">{{ item.label }}</span>
      <span class="sb-count">{{ item.count }}</span>
    </span>
  </div>

</div>